import { useSearchParams } from 'react-router-dom'
import { Button } from 'vnetwork-ui'
import DownLoadIcons from '@/icons/DownLoadIcons'
import { useTranslation } from 'react-i18next'
import toast from 'react-hot-toast'
import { exportTickets } from '@/modules/Ticket/services'

const ExportTicketButton: React.FC = () => {
    const { t } = useTranslation()
    const [searchParams] = useSearchParams()

    const handleExport = async () => {
        try {
            const filters = searchParams.get('filters') || ''

            const payload = {
                page: 1,
                page_size: 99999,
                q: '',
                filters: filters,
            }
            const response = await exportTickets(payload)

            // Tạo URL từ Blob
            const url = window.URL.createObjectURL(new Blob([response]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
                'download',
                `tickets_${new Date().toISOString()}.xlsx`
            )

            // Kích hoạt tải file
            document.body.appendChild(link)
            link.click()

            // Dọn dẹp bộ nhớ
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)

            toast.success(t('dowload-success'))
        } catch (error) {
            console.error('Lỗi khi tải file Excel:', error)
            alert('Đã xảy ra lỗi khi xuất file Excel.')
        }
    }

    return (
        <Button
            size="small"
            variant="contained"
            className="w-full"
            startIcon={<DownLoadIcons style={{ margin: -4 }} />}
            onClick={handleExport}
        >
            {t('download')}
        </Button>
    )
}

export default ExportTicketButton
